import type { CompanyInvoiceReceivers } from './types';

import { ENDPOINT } from '~/constants/endpoints';

import { type UUID } from '~/types/common';

import type { KyRequestOptions } from '@vestigas/data';

import { vestigasApi } from '~/services/kyClient';

import { zodCompanyInvoiceReceiversResponseSchema } from './validations';

/**
 * Fetches invoice receiver email addresses configured for a company.
 *
 * @param companyId - The ID of the company to fetch.
 * @param options - Request options supplied by TanStack Query.
 * @returns The company's invoice receiver email addresses.
 * @see https://app.dev.vestigas.com/redoc#tag/Company/operation/get_company_invoice_receivers_company__id__invoice_receivers_get
 */
export const fetchCompanyInvoiceReceivers = async (
  companyId: UUID,
  options?: KyRequestOptions,
) => {
  const response = await vestigasApi
    .get(ENDPOINT.COMPANY.GET_INVOICE_RECEIVERS(companyId), {
      ...options,
      validate: {
        ...options?.validate,
        response: zodCompanyInvoiceReceiversResponseSchema,
      },
    })
    .json<CompanyInvoiceReceivers>();

  return zodCompanyInvoiceReceiversResponseSchema.parse(response);
};
